export const isSpringSeasonCampaignActive = (): boolean => {
  const currentTime = new Date().getTime();
  const campaignStartDate = new Date('2025-03-01');
  const campaignEndDate = new Date('2025-06-04');

  campaignStartDate.setHours(0, 0, 0, 0);
  campaignEndDate.setHours(23, 59, 59, 999);

  return currentTime >= campaignStartDate.getTime() && currentTime <= campaignEndDate.getTime();
};

export const isSummerSeasonCampaignActive = (): boolean => {
  const currentTime = new Date().getTime();
  const campaignStartDate = new Date('2025-06-05');

  campaignStartDate.setHours(0, 0, 0, 0);

  return currentTime >= campaignStartDate.getTime();
};
